<template>
  <th colspan="1" rowspan="1" @click="sortValue">
    <div class="vs-table-text">
      <slot />
      <span
        v-if="isColumnSelectedForSort && currentSort !== 0"
        class="sort-th"
      >
        <vs-icon
          class="th-sort-icon"
          :icon="currentSort === 1 ? 'expand_less' : 'expand_more'"
        />
      </span>
    </div>
  </th>
</template>

<script>
export default {
  name: "VsTh",
  inject: ["vsTable"],
  props: {
    sortKey: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      currentSort: 0,
      sortStatuses: [null, "asc", "desc"],
    };
  },
  computed: {
    isColumnSelectedForSort() {
      if (!this.sortKey) return false;
      if (this.vsTable.currentSortKey !== this.sortKey) this.resetSort();
      return this.vsTable.currentSortKey === this.sortKey;
    },
  },
  methods: {
    sortValue() {
      if (!this.sortKey) return;
      this.currentSort = this.currentSort !== 2 ? this.currentSort + 1 : 0;
      this.vsTable.sort(
        this.sortKey,
        this.sortStatuses[this.currentSort]
      );
    },
    resetSort() {
      this.currentSort = 0;
    },
  },
};
</script>
